import { CmsProtectionDetails } from '../../models/protection-details/cms-protection-details.interface';

export const mockCmsProtectionDetails: CmsProtectionDetails = {
  protectionDetailsBannerContent: 'protectionDetailsBannerContent',
  protectionDetailsNotice: 'protectionDetailsNotice',
  protectionDetailsPageTitle: 'protectionDetailsPageTitle',
};
